import moment from 'moment';

import { TextInput } from '../TextInput';

import styles from './DurationPicker.module.scss';
import { DurationPickerProps } from './DurationPicker.types';

export const DurationPicker = ({
  duration,
  onChange,
  inputContainerClassName,
  containersClassName,
}: DurationPickerProps) => (
  <div className={styles.durationPicker}>
    <TextInput
      size="small"
      type="number"
      className={styles.input}
      containerClassName={inputContainerClassName ?? containersClassName}
      value={Math.floor(duration.asHours())}
      onChange={event => {
        const value = (event.target as HTMLInputElement).value;
        onChange(moment.duration({ hours: Number(value), minutes: duration.minutes() }));
      }}
    />
    h
    <TextInput
      size="small"
      type="number"
      className={styles.input}
      containerClassName={inputContainerClassName ?? containersClassName}
      value={duration.minutes()}
      onValueChange={value => {
        if (Number(value) < 60) {
          onChange(
            moment.duration({ hours: Math.floor(duration.asHours()), minutes: Number(value) })
          );
        }
      }}
    />
    min
  </div>
);
